export const fr = {
  pwa: {
    update: "Mettre à jour",
    updateDescription: "Une nouvelle mise à jour de l'application a été détectée",
    updateTitle: "Mise à jour disponible",
  },
};
